import { AbstractControl } from '@angular/forms';

export function WorksiteMin(minLength: number) {
  return (control: AbstractControl) => {
    if (control.value) {
      const parsedValue = JSON.parse(control.value);
      const numberOfProjektparter = parsedValue.length;

      if (numberOfProjektparter < minLength) {
        return { WorksiteMin: true };
      }
    }
  };
}
